export default "__VITE_ASSET__p9HlAxy4__"